import React, { FC, useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { ComboboxProps, Option } from "@fluentui/react-components";

import { IUhfViewState } from "../../../../pages/Contracts";
import { IRapComponentProperties } from "../../../../platform/Layout";
import { ITestConfiguration } from "../../Contracts";
import { TestActions } from "../../redux/TestActions";
import { LabeledCombobox } from "../../../../common/components/LabeledCombobox/LabeledCombobox";
import { localizedStrings } from "../../../../common/localization/LocalizedStrings";

import * as TestSelectors from "../../redux/TestSelectors";

interface IHeaderSelectorProvidedProps extends IRapComponentProperties {
    className?: string;
}

interface IHeaderSelectorOwnProps {
    testConfig: ITestConfiguration;
}

export type IHeaderSelectorProps = ConnectedProps<typeof connector> & IHeaderSelectorProvidedProps;

const HeaderSelectorInitializer: FC<IHeaderSelectorProps> = (props) => {
    const [options, setOptions] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState(false);



    useEffect(() => {
        setIsLoading(true);
        props.fetchPartnerHeaders(props.testConfig?.partnerId).then(headers => {
            setOptions(headers);
            if(headers && !props.testConfig?.headerId) {
                props.setTestConfig({ headerId: headers[0] });
            }
        }).finally(() => {  
            setIsLoading(false);
        })

    }, [props.testConfig?.partnerId]);

    const onOptionSelect: ComboboxProps["onOptionSelect"] = (event, data) => {
        props.setTestConfig({ headerId: data.optionText });
    }

    return (
        <div className={`${props.className ? props.className : ""}`}>
            <LabeledCombobox label={localizedStrings.TestView?.TestConfigurator?.headerId} onOptionSelect={onOptionSelect} value={props.testConfig.headerId} disabled={isLoading}>
                {options?.map(opt => {
                    return (
                        <Option key={opt}>
                            {opt}
                        </Option>
                    );
                })}
            </LabeledCombobox>
        </div>
    );
}

function mapStateToProps(state: IUhfViewState, providedProps: IHeaderSelectorProvidedProps): Partial<IHeaderSelectorOwnProps> {
    return {
        ...providedProps,
        testConfig: TestSelectors.getTestConfig(state)
    };
}

const ActionsToDispatch = {
    setTestConfig: TestActions.setTestConfig,
    fetchPartnerHeaders: TestActions.fetchPartnerHeaders
};

const connector = connect(
    mapStateToProps,
    ActionsToDispatch,
    null,
    { forwardRef: true }
);

export const HeaderSelector = connector(HeaderSelectorInitializer);